import { render, staticRenderFns } from "./cohortSubs.vue?vue&type=template&id=41a6eda3&scoped=true"
import script from "./cohortSubs.vue?vue&type=script&lang=js"
export * from "./cohortSubs.vue?vue&type=script&lang=js"
import style0 from "./cohortSubs.vue?vue&type=style&index=0&id=41a6eda3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a6eda3",
  null
  
)

export default component.exports